import DocumentTitle from 'react-document-title';

import FolderNotFound from 'hb-react/frontoffice/apps/MediaCenter/components/FolderNotFound';
import BlocksRenderer from 'hb-react/frontoffice/components/BlocksRenderer';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';
import { type Topic } from 'hb-react/types';

interface EmptyFolderRendererProps {
  appHeaderProps: Record<string, unknown>;
  topic?: Topic;
}

export const EmptyFolderRenderer = ({
  topic,
  appHeaderProps,
}: EmptyFolderRendererProps) => {
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: __('Media Center'),
          networkName: getPageTitleFromNetwork(currentNetwork),
          topicName: topic?.name,
        })}
      />
      <BlocksRenderer
        templateProps={{
          topicId: topic?.id,
          hasFilters: false,
        }}
        blocks={[
          {
            ...BLOCKS.appHeader,
            attributes: {
              ...appHeaderProps,
            },
          },
          () => <FolderNotFound />,
        ]}
      />
    </>
  );
};
